export default async function readFileAsArrayBuffer(file) {
  const response = await fetch(file);
  const arrayBuffer = await response.arrayBuffer();
  return arrayBuffer;
}